import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Card, CardContent, CircularProgress, Stack, Typography } from "@mui/material";

export default function PublicMusicSong() {
  const { token } = useParams();
  const [state, setState] = React.useState({
    loading: true,
    err: "",
    title: "",
    instrumental: false,
    tracks: [],
  });

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/music/public/song/${encodeURIComponent(token || "")}`,
        );
        if (cancelled) return;
        if (!res.data?.success) {
          setState({
            loading: false,
            err: "Not found or not shared.",
            title: "",
            instrumental: false,
            tracks: [],
          });
          return;
        }
        const d = res.data.data || {};
        setState({
          loading: false,
          err: "",
          title: d.title || "",
          instrumental: Boolean(d.instrumental),
          tracks: Array.isArray(d.tracks) ? d.tracks : [],
        });
      } catch {
        if (!cancelled)
          setState({
            loading: false,
            err: "Could not load this page.",
            title: "",
            instrumental: false,
            tracks: [],
          });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (state.loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (state.err) {
    return (
      <Box sx={{ maxWidth: 720, mx: "auto", py: 6, px: 2 }}>
        <Typography color="text.secondary">{state.err}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 720, mx: "auto", py: 4, px: 2 }}>
      <Typography variant="h5" gutterBottom>
        {state.title || "Shared song"}
      </Typography>
      {state.instrumental && (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
          Instrumental
        </Typography>
      )}
      <Stack spacing={2}>
        {state.tracks.map((tr, i) => (
          <Card key={tr.audio_url || i} variant="outlined">
            <CardContent>
              <Typography variant="subtitle2" gutterBottom>
                {tr.title || `Track ${i + 1}`}
              </Typography>
              {tr.audio_url ? (
                <Box component="audio" controls src={tr.audio_url} sx={{ width: "100%", mt: 1 }} />
              ) : (
                <Typography variant="caption" color="text.secondary">
                  No audio URL
                </Typography>
              )}
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
